import { Box } from '@mui/material'

const Footer = () => {
  const styles = {
    footer: {
      width: '100%',
      height: '250px',
      background: 'linear-gradient(to right, #285D96, #0D0F21)',
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'space-between',
      padding: { xs: '20px', sm: '80px' },
      alignItems: 'center',
      marginTop: '100px',
      gap: { xs: '10px', sm: 0 },
      boxSizing: 'border-box'
    },
    leftSection: {
      textAlign: { xs: 'center', sm: 'left' },
      width: { xs: '100%', sm: 'auto' },
      mb: { xs: '20px', sm: 0 }
    },
    rightSection: {
      textAlign: { xs: 'center', sm: 'right' },
      width: { xs: '100%', sm: 'auto' },
      mb: { xs: '25px', sm: 0 }
    },
    logo: {
      position: 'relative',
      width: '180px',
      height: 'auto',
      maxHeight: '50px',
      top: { xs: 'auto', sm: '20%' }
    },
    text: {
      position: 'relative',
      color: 'white',
      fontSize: { xs: '9px', sm: '16px' },
      top: { xs: 'auto', sm: '30%' }
    },
    evoText: {
      position: 'relative',
      color: 'white',
      fontSize: { xs: '9px', sm: '16px' },
      textAlign: { xs: 'center', sm: 'left' }
    },
    evoLogo: {
      position: 'relative',
      width: { xs: '100px', sm: '180px' },
      height: 'auto'
    }
  }

  return (
    <Box component='footer' sx={styles.footer}>
      <Box sx={styles.leftSection}>
        <Box component='img' src='/assets/BirthcareReverse.png' alt='Logo' sx={styles.logo} />
        <Box component='p' sx={styles.text}>
          Copyright © {new Date().getFullYear()} Evolution Healthcare - All Rights Reserved.<br />
          No information or material can be copied or distributed without our express permission.
        </Box>
        <Box
          component='a'
          href='https://birthcare.co.nz/privacy-policy/'
          target='_blank'
          rel='noreferrer'
          sx={{ ...styles.text, textDecoration: 'none' }}
        >
          Privacy Statement
        </Box>
      </Box>
      <Box sx={styles.rightSection}>
        <Box component='p' sx={styles.evoText}>Proudly part of</Box>
        <Box component='img' src='/assets/Evolution.png' alt='EvoLogo' sx={styles.evoLogo} />
      </Box>
    </Box>
  )
}

export default Footer